import { Outlet } from 'react-router-dom'

const DiscoverPage = () => {
  return (
    <div className='mx-6'>
      <div className='mt-4'>
        <Outlet />
      </div>
    </div>
  )
}

export default DiscoverPage
